export default __webpack_public_path__ + "static/media/myapps_img.39d36297.svg";